import React, {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import { useMediaQuery } from "@mui/material";

interface ResponsiveContextValues {
  onTablet: boolean;
  onMobile: boolean;
  isTouchScreen: boolean;
}

const ResponsiveContext = createContext<ResponsiveContextValues>({
  onTablet: false,
  onMobile: false,
  isTouchScreen: false,
});

export const useResponsiveContext = (): ResponsiveContextValues =>
  useContext(ResponsiveContext);

const ResponsiveContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const onTablet = useMediaQuery("(max-width:899px)");
  const onMobile = useMediaQuery("(max-width:500px)");
  const [isTouchScreen, setIsTouchScreen] = useState(false);

  useEffect(() => {
    setIsTouchScreen("ontouchstart" in window || navigator.maxTouchPoints > 0);
  }, []);

  return (
    <ResponsiveContext.Provider
      value={{
        onTablet,
        onMobile,
        isTouchScreen,
      }}
    >
      {children}
    </ResponsiveContext.Provider>
  );
};

export default ResponsiveContextProvider;
